import { useMemo } from 'react';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceName } from './name.types';

type SettlementServiceNameFieldProps = FieldControllerProps<'name', MedicalServiceName | null> & {
   readonly disabled?: boolean;
};

export const MedicalServiceNameField = (props: SettlementServiceNameFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
         maxLength: 150,
      };
   }, [props.required]);

   return (
      <TextInput
         testId={props.name}
         label={medicalServiceTranslationKeys.shared.name.field.label}
         placeholder={medicalServiceTranslationKeys.shared.name.field.placeholder}
         controller={props.register(props.name, validationRules)}
         defaultValue={props.defaultValue}
         disabled={props.disabled}
      />
   );
};
